function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import queryParameters from './queryParameters';
import cookieParameters from './cookieParameters';
import * as visitParameters from './visitParameters';
import log from './log';
var trackingSettings = {
  localStorageName: '_attrbjs',
  limitVisits: 5,
  trackQueryParameters: ['utm_campaign', 'utm_medium', 'utm_source', 'utm_content', 'utm_term', 'ref', 'fbclid'],
  trackCookies: [
  /* Facebook Cookies: https://developers.facebook.com/docs/marketing-api/facebook-pixel/server-side-api/parameters#fbc */
  '_fbc', '_fbp',
  /* Google Analytics */
  '_ga', '_gid', '__utma', '__utmb', '__utmc', '__utmz', '__utmv', '__utmx', '__utmxx',
  /* Google Optimize */
  '_gaexp', '_opt_awcid', '_opt_awmid', '_opt_awgid', '_opt_awkid', '_opt_utmc'],
  trackReferrer: true,
  ignoreVisitsWithoutUTMParameters: true,
  visitFilterFunction: null,
  // Only accept visits if this function returns true
  debug: false
};
var thisVisit = null;
export var save = function save() {
  // Set cookie data
  var previousVisits = visitParameters.get(trackingSettings);
  thisVisit = {
    time: new Date().toUTCString(),
    query: queryParameters(trackingSettings),
    cookies: cookieParameters(trackingSettings),
    page: window.location.href
  };

  if (trackingSettings.trackReferrer) {
    thisVisit.referrer = document.referrer;
  }

  if (trackingSettings.ignoreVisitsWithoutUTMParameters) {
    var shouldIgnore = true;
    Object.keys(thisVisit.query || {}).forEach(function (key) {
      if (/utm/i.test(key)) {
        shouldIgnore = false;
      }
    });

    if (shouldIgnore) {
      log('Ignoring visit, no UTM parameters found.');
      return;
    }
  }

  if (trackingSettings.visitFilterFunction) {
    if (!trackingSettings.visitFilterFunction(thisVisit)) {
      log('Ignoring visit, visitFilterFunction returned falsey.');
      return;
    }
  }

  var visits = [].concat(_toConsumableArray(previousVisits), [thisVisit]).filter(function (t) {
    return !!t;
  });

  if (visits.length > trackingSettings.limitVisits) {
    visits = [visits[0]].concat(_toConsumableArray(visits.splice(2, visits.length)));
  }

  visitParameters.set(trackingSettings, visits);
  return thisVisit;
};
export var settings = function settings(options) {
  if (options) {
    trackingSettings = _objectSpread(_objectSpread({}, trackingSettings), options);
  }

  return trackingSettings;
};
export var params = function params() {
  if (!thisVisit) {
    save();
  }

  return thisVisit;
};
export var firstClickParams = function firstClickParams() {
  var visits = visitParameters.get(trackingSettings);
  return visits[0];
};
export var historicalParams = function historicalParams() {
  return visitParameters.get(trackingSettings);
};